export function formatLink(url: string) {
  // Regular expression patterns
  const patternHttp = /^http:\/\//i;
  const patternHttps = /^https:\/\//i;
  const patternWww = /^(https?:\/\/)?(www\.)?/i;

  // Check if the link starts with http:// or https://
  if (!patternHttp.test(url) && !patternHttps.test(url)) {
    url = 'http://' + url; // Default to http:// if no protocol is specified
  }

  // Check if the link starts with http:// or https:// and does not have www.
  if (patternHttp.test(url) || patternHttps.test(url)) {
    if (!patternWww.test(url)) {
      url = url.replace(/^(https?:\/\/)/i, '$1www.');
    }
  }

  return url;
}
